import { render, staticRenderFns } from "./ShipmentList.vue?vue&type=template&id=41fa7a52&scoped=true&"
import script from "./ShipmentList.vue?vue&type=script&lang=js&"
export * from "./ShipmentList.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentList.vue?vue&type=style&index=0&id=41fa7a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fa7a52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41fa7a52')) {
      api.createRecord('41fa7a52', component.options)
    } else {
      api.reload('41fa7a52', component.options)
    }
    module.hot.accept("./ShipmentList.vue?vue&type=template&id=41fa7a52&scoped=true&", function () {
      api.rerender('41fa7a52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Shipments/ShipmentList.vue"
export default component.exports